import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {
  baseStyles,
  BORDER_RADIUS,
  FIELD_SPACE,
  VIEW_BESIDE_PREVIEW_MAX_WIDTH,
  withMediaQueries,
  withMultipleStyles
} from "../../../styles/Styles";
import Space from "../commons/Space";
import TextField from "@material-ui/core/TextField";
import ValueHelper, {textFieldIntegerOnKeyDown} from "../../utils/ValueHelper";
import constants from "../../constants";
import DateTimeHelper from "../../utils/DateTimeHelper";
import TextView from "../commons/TextView";
import {FontWeightMedium} from "../../../res/FontWeight";
import FullWidthDummyView from "../commons/FullWidthDummyView";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import FormHelperText from "@material-ui/core/FormHelperText";
import {ColorField, ColorFieldBorder} from "../../../styles/Colors";
import FieldSpace from "src/js/components/commons/FieldSpace";

const useStyles = () => ({

});

class ManageActivityElements extends React.Component {

  constructor(props) {
    super(props);
    const {activityData} = this.props;

    this.minGamesCount = 0;
    this.minTriesCount = 0;
    if (activityData.activityConfigs) {
      this.minGamesCount = activityData.activityConfigs.minGamesCount;
      this.minTriesCount = activityData.activityConfigs.minTriesCount;
    }
    this.maxTriesCount = constants.activity.VALUE_SPIN_MAX;
    if (activityData.type === constants.activity.types.GAME_FLIP_CARD) {
      this.maxTriesCount = 24;
    }

    let consumableWSunday = false;
    let consumableWMonday = false;
    let consumableWTuesday = false;
    let consumableWWednesday = false;
    let consumableWThursday = false;
    let consumableWFriday = false;
    let consumableWSaturday = false;
    if (activityData.type === constants.activity.types.OFFER) {
      activityData.consumableWDays.forEach((value) => {
          if (value == '1') {
            consumableWSunday = true;
          } else if (value == '2') {
            consumableWMonday = true;
          } else if (value == '3') {
            consumableWTuesday = true;
          } else if (value == '4') {
            consumableWWednesday = true;
          } else if (value == '5') {
            consumableWThursday = true;
          } else if (value == '6') {
            consumableWFriday = true;
          } else if (value == '7') {
            consumableWSaturday = true;
          }
      });
    }

    let hourStartAt = null;
    if (activityData.hourStartAt) {
      hourStartAt = activityData.hourStartAt instanceof Date ? activityData.hourStartAt : DateTimeHelper.getDateFromDateString(activityData.hourStartAt);
    }
    let hourEndAt = null;
    if (activityData.hourEndAt) {
      hourEndAt = activityData.hourEndAt instanceof Date ? activityData.hourEndAt : DateTimeHelper.getDateFromDateString(activityData.hourEndAt);
    }

    this.state = {
      showAnswers: activityData.showAnswers,
      correction: activityData.correction,
      gameTime: activityData.gameTime / 1000,
      consumeLimit: activityData.consumeLimit && activityData.consumeLimit != constants.activity.VALUE_DEFAULT_MAX ? ''+ activityData.consumeLimit : '',
      consumeLimitPerUser: activityData.consumeLimitPerUser && activityData.consumeLimitPerUser != constants.activity.VALUE_DEFAULT_MAX ? ''+ activityData.consumeLimitPerUser : '',
      flipsNeeded: activityData.flipsNeeded || '0',
      winnersByValue: activityData.winnersByValue,

      onlyBirthday: activityData.onlyBirthday == true,
      inChallenge: activityData.inChallenge == true,
      inTraining: activityData.inTraining == true,
      displayLimitPerUser: activityData.displayLimitPerUser && activityData.displayLimitPerUser != constants.activity.VALUE_DEFAULT_MAX ? ''+ activityData.displayLimitPerUser : '',
      consumeLimitPerDay: activityData.consumeLimitPerDay && activityData.consumeLimitPerDay != constants.activity.VALUE_DEFAULT_MAX ? ''+ activityData.consumeLimitPerDay : '',
      winLimitPerUser: activityData.winLimitPerUser && activityData.winLimitPerUser != constants.activity.VALUE_DEFAULT_MAX ? ''+ activityData.winLimitPerUser : '',
      clickLimit: activityData.clickLimit && activityData.clickLimit != constants.activity.VALUE_DEFAULT_MAX ? ''+ activityData.clickLimit : '',
      consumableWSunday: consumableWSunday,
      consumableWMonday: consumableWMonday,
      consumableWTuesday: consumableWTuesday,
      consumableWWednesday: consumableWWednesday,
      consumableWThursday: consumableWThursday,
      consumableWFriday: consumableWFriday,
      consumableWSaturday: consumableWSaturday,
      hourStartAt: hourStartAt,
      hourEndAt: hourEndAt,
      showValidationMsg: false,
    };
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
  }

  componentWillUnmount() {
  }

  updateState(fields) {
    this.setState(fields, () => {
      this.props.onDataUpdated(this.getData(true));
    });
  }

  getData(excludeError) {
    const {activityData} = this.props;
    const {
      showAnswers,
      correction,
      gameTime,
      consumeLimit,
      consumeLimitPerUser,
      flipsNeeded,
      winnersByValue,

      onlyBirthday,
      inChallenge,
      inTraining,
      displayLimitPerUser,
      consumeLimitPerDay,
      winLimitPerUser,
      clickLimit,
      consumableWSunday,
      consumableWMonday,
      consumableWTuesday,
      consumableWWednesday,
      consumableWThursday,
      consumableWFriday,
      consumableWSaturday,
      hourStartAt,
      hourEndAt
    } = this.state;

    const consumableWDays = [];
    if (consumableWSunday) {
      consumableWDays.push('1');
    }
    if (consumableWMonday) {
      consumableWDays.push('2');
    }
    if (consumableWTuesday) {
      consumableWDays.push('3');
    }
    if (consumableWWednesday) {
      consumableWDays.push('4');
    }
    if (consumableWThursday) {
      consumableWDays.push('5');
    }
    if (consumableWFriday) {
      consumableWDays.push('6');
    }
    if (consumableWSaturday) {
      consumableWDays.push('7');
    }

    if (!excludeError) {
      if (activityData.type === constants.activity.types.JACKPOT
        || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
        || activityData.type === constants.activity.types.GAME_BRAND_RACE
        || activityData.type === constants.activity.types.GAME_POKER
        || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
        || activityData.type === constants.activity.types.GAME_BETTING_PIC
        || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
        || activityData.type === constants.activity.types.GAME_MATCH_PAIR
        || activityData.type === constants.activity.types.GAME_MATCH_THREE) {
        if (!consumeLimit || ValueHelper.getEnglishValue(consumeLimit) < this.minGamesCount
          || !consumeLimitPerUser || ValueHelper.getEnglishValue(consumeLimitPerUser) < this.minTriesCount
        ) {
          this.updateState({showValidationMsg: true});
          return false;
        }
      } else if (activityData.type === constants.activity.types.GAME_FLIP_CARD) {
        if (!consumeLimit || ValueHelper.getEnglishValue(consumeLimit) < this.minGamesCount
          || !flipsNeeded || ValueHelper.getEnglishValue(flipsNeeded) < this.minTriesCount || ValueHelper.getEnglishValue(flipsNeeded) > this.maxTriesCount
        ) {
          this.updateState({showValidationMsg: true});
          return false;
        }
      } else if (activityData.type === constants.activity.types.QUESTIONNAIRE) {
        if (!consumeLimit || ValueHelper.getEnglishValue(consumeLimit) < this.minGamesCount
          || (!winnersByValue && winnersByValue !== 0)
          || ValueHelper.getEnglishValue(winnersByValue) < 0
          || ValueHelper.getEnglishValue(winnersByValue) > activityData.questions.length) {
          this.updateState({showValidationMsg: true});
          return false;
        }
      }
    }

    const data = {
      showAnswers,
      correction,
      gameTime: gameTime * 1000,
      consumeLimit,
      consumeLimitPerUser,
      flipsNeeded,
    }
    if (activityData.type === constants.activity.types.QUESTIONNAIRE) {
      data.winnersBy = 1;
      data.winnersByValue = winnersByValue;
    }
    return data;
  }

  render() {
    const {activityData, app, classes, isXS} = this.props;
    const {
      showAnswers,
      correction,
      gameTime,
      consumeLimit,
      consumeLimitPerUser,
      flipsNeeded,
      winnersByValue,

      onlyBirthday,
      inChallenge,
      inTraining,
      displayLimitPerUser,
      consumeLimitPerDay,
      winLimitPerUser,
      clickLimit,
      consumableWSunday,
      consumableWMonday,
      consumableWTuesday,
      consumableWWednesday,
      consumableWThursday,
      consumableWFriday,
      consumableWSaturday,
      hourStartAt,
      hourEndAt,
      showValidationMsg
    } = this.state;

    let consumeLimitTextKey = null;
    let consumeLimitPerUserTextKey = null;
    if (activityData.type === constants.activity.types.JACKPOT
      || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
      || activityData.type === constants.activity.types.GAME_BETTING_PIC
      || activityData.type === constants.activity.types.GAME_ROULETTE
      || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
      || activityData.type === constants.activity.types.GAME_POKER
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
      || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.GAME_BRAND_RACE
      || activityData.type === constants.activity.types.QUESTIONNAIRE
      || activityData.type === constants.activity.types.SURVEY
    ) {
      consumeLimitTextKey = 'activity.gamesCount';
      if (activityData.type === constants.activity.types.GAME_FLIP_CARD
        || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
        || activityData.type === constants.activity.types.GAME_MATCH_PAIR
        || activityData.type === constants.activity.types.GAME_MATCH_THREE
        || activityData.type === constants.activity.types.GAME_PUZZLE
        || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
        || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      ) {
        consumeLimitPerUserTextKey = 'activity.flipsPerGame';
      } else if (activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
        || activityData.type === constants.activity.types.GAME_POKER) {
        consumeLimitPerUserTextKey = 'activity.roundsPerGame';
      } else {
        consumeLimitPerUserTextKey = 'activity.spinsPerGame';
      }
    } else {
      consumeLimitTextKey = 'activity.manage.consumeLimit';
      consumeLimitPerUserTextKey = 'activity.manage.consumeLimitPerUser';
    }

    const showConsumableDays = activityData.type === constants.activity.types.OFFER;
    const showConsumableTime = activityData.type === constants.activity.types.OFFER;
    const showWinLimitPerUser = activityData.type === constants.activity.types.JACKPOT
      || activityData.type === constants.activity.types.GAME_ROULETTE
      || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
      || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.GAME_BRAND_RACE
      || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
      || activityData.type === constants.activity.types.GAME_POKER;
    // const showGameTries = activityData.type === constants.activity.types.JACKPOT
    //   || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
    //   || activityData.type === constants.activity.types.GAME_BETTING_PIC
    //   || activityData.type === constants.activity.types.GAME_ROULETTE
    //   || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
    //   || activityData.type === constants.activity.types.GAME_FLIP_CARD
    //   || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
    //   || activityData.type === constants.activity.types.GAME_MATCH_PAIR
    //   || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
    //   || activityData.type === constants.activity.types.GAME_POKER
    //   || activityData.type === constants.activity.types.GAME_MATCH_THREE
    //   || activityData.type === constants.activity.types.GAME_PUZZLE
    //   || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
    //   || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
    //   || activityData.type === constants.activity.types.GAME_BRAND_RACE
    //   || activityData.type === constants.activity.types.QUESTIONNAIRE;
    const showGameTries = false;
    // const showPlayTries = activityData.type === constants.activity.types.JACKPOT
    //   || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
    //   || activityData.type === constants.activity.types.GAME_BETTING_PIC
    //   || activityData.type === constants.activity.types.GAME_ROULETTE
    //   || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
    //   || activityData.type === constants.activity.types.GAME_FLIP_CARD
    //   || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
    //   || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
    //   || activityData.type === constants.activity.types.GAME_POKER
    //   || activityData.type === constants.activity.types.GAME_BRAND_RACE;
    const showPlayTries = false;
    const playTriesFieldName =  activityData.type === constants.activity.types.GAME_FLIP_CARD ? 'flipsNeeded' : 'consumeLimitPerUser';
    const playTriesMaxValue =  activityData.type === constants.activity.types.GAME_FLIP_CARD ? 24 : constants.activity.VALUE_SPIN_MAX;
    const playTriesValue =  activityData.type === constants.activity.types.GAME_FLIP_CARD ? flipsNeeded : consumeLimitPerUser;
    const showWinProbability = false; // activityData.type === constants.activity.types.JACKPOT;
    const showAnswerResults = activityData.type === constants.activity.types.QUESTION;
    const showCheckRightOption = activityData.type === constants.activity.types.QUESTIONNAIRE;
    const showGameTime = activityData.type === constants.activity.types.QUESTIONNAIRE;
    const showParticipateLimit = activityData.type === constants.activity.types.EVENT;
    const showInFunSwitch = activityData.type === constants.activity.types.QUESTIONNAIRE;
    const showInTrainingSwitch = activityData.type === constants.activity.types.QUESTIONNAIRE;

    let consumeError = null;
    let consumeLimitPerUserError = null;
    let winnersByValueError = null;
    if (showValidationMsg) {
      if (!consumeLimit || ValueHelper.getEnglishValue(consumeLimit) < this.minGamesCount) {
        consumeError = <FormattedMessage id='activity.validation.requiredValueOrMore' values={{value: this.minGamesCount}}/>;
      }
      if (this.maxTriesCount > 0) {
        if (!consumeLimitPerUser || ValueHelper.getEnglishValue(consumeLimitPerUser) < this.minTriesCount || ValueHelper.getEnglishValue(consumeLimitPerUser) > this.maxTriesCount) {
          consumeLimitPerUserError = <FormattedMessage id='activity.validationValueBetween' values={{value1: this.minTriesCount, value2: this.maxTriesCount}} />;
        }
      } else {
        if (!consumeLimitPerUser || ValueHelper.getEnglishValue(consumeLimitPerUser) < this.minTriesCount) {
          consumeLimitPerUserError = <FormattedMessage id='activity.validation.requiredValueOrMore' values={{value: this.minTriesCount}} />;
        }
      }
      if (activityData.type === constants.activity.types.QUESTIONNAIRE) {
        if ((!winnersByValue && winnersByValue !== 0) || ValueHelper.getEnglishValue(winnersByValue) < 0 || ValueHelper.getEnglishValue(winnersByValue) > activityData.questions.length) {
          winnersByValueError = <FormattedMessage id='activity.validationBetween' values={{value1: 0, value2: activityData.questions.length}}/>;
        }
      }
    }

    const winProbability = 1/(6^4) * consumeLimitPerUser * consumeLimit;

    return (
      <div className={classes.formActivity}>
        {activityData.type === constants.activity.types.QUESTIONNAIRE ?
          <React.Fragment>
            <TextField
              variant="filled"
              fullWidth
              size="small"
              type="number"
              id="winnersByValue"
              name="winnersByValue"
              label={<FormattedMessage id={'activity.minCorrectAnswersCount'} />}
              value={winnersByValue}
              InputProps={{disableUnderline: true}}
              inputProps={{min: 0, max: activityData.questions.length}}
              onChange={this.onChange}
              onKeyDown={textFieldIntegerOnKeyDown}
              error={winnersByValueError}
              helperText={winnersByValueError || <FormattedMessage id={'activity.correctAnswersCountHint'} values={{value: activityData.questions.length}} />}
            />
            <FieldSpace />
          </React.Fragment>
          : null
        }

        {/*{showGameTries || showPlayTries ?*/}
        {/*  <div className={classes.viewColumnFullWidth}>*/}
        {/*    <div className={classes.viewRowFullWidthNoCenter}>*/}
        {/*      {showGameTries ?*/}
        {/*        <div className={classes.flexColumn}>*/}
        {/*          <TextField*/}
        {/*            required*/}
        {/*            variant="filled"*/}
        {/*            fullWidth*/}
        {/*            size="small"*/}
        {/*            type="number"*/}
        {/*            id="consumeLimit"*/}
        {/*            name="consumeLimit"*/}
        {/*            label={<FormattedMessage id={consumeLimitTextKey}/>}*/}
        {/*            value={consumeLimit}*/}
        {/*            InputProps={{disableUnderline: true}}*/}
        {/*            inputProps={{min: 1, max: constants.activity.VALUE_DEFAULT_MAX}}*/}
        {/*            onChange={this.onChange}*/}
        {/*            onKeyDown={textFieldIntegerOnKeyDown}*/}
        {/*            error={showValidationMsg && consumeError != null}*/}
        {/*            helperText={showValidationMsg && consumeError != null ? consumeError : null}*/}
        {/*          />*/}
        {/*        </div>*/}
        {/*        : null*/}
        {/*      }*/}

        {/*      {showPlayTries ?*/}
        {/*        <div className={classes.flexColumn} style={{marginLeft: 8}}>*/}
        {/*          <TextField*/}
        {/*            required*/}
        {/*            variant="filled"*/}
        {/*            fullWidth*/}
        {/*            size="small"*/}
        {/*            type="number"*/}
        {/*            id={playTriesFieldName}*/}
        {/*            name={playTriesFieldName}*/}
        {/*            label={<FormattedMessage id={consumeLimitPerUserTextKey} />}*/}
        {/*            value={playTriesValue}*/}
        {/*            InputProps={{disableUnderline: true}}*/}
        {/*            inputProps={{min: 1, max: playTriesMaxValue}}*/}
        {/*            onChange={this.onChange}*/}
        {/*            onKeyDown={textFieldIntegerOnKeyDown}*/}
        {/*            error={showValidationMsg && consumeLimitPerUserError != null}*/}
        {/*            helperText={showValidationMsg && consumeLimitPerUserError != null ? consumeLimitPerUserError : null}*/}
        {/*          />*/}
        {/*        </div>*/}
        {/*        : null*/}
        {/*      }*/}
        {/*    </div>*/}
        {/*    {showWinProbability ?*/}
        {/*      <TextView variant={'body2'} fontWeight={FontWeightMedium} style={{marginTop: 12, marginBottom: -8}}><FormattedMessage id={'activity.winProbability'} values={{value: winProbability}} /></TextView>*/}
        {/*      : null*/}
        {/*    }*/}
        {/*    <Space horizontal={inputSpace}/>*/}
        {/*  </div> : null*/}
        {/*}*/}

        {showAnswerResults ?
          <div className={classes.viewColumnFullWidthNoCenter}>
            <div className={classes.flexRow} style={{marginTop: -8, marginBottom: -8}}>
              <FormControlLabel
                style={{marginLeft: 0, marginRight: 0}}
                control={
                  <div style={{marginLeft: app.isLTR ? 30 : 0, marginRight: app.isLTR ? 30 : 0}}>
                    <Switch
                      checked={showAnswers}
                      onChange={this.onChecked}
                      id="showAnswers"
                      name="showAnswers"
                      color="primary"
                    />
                  </div>
                }
                labelPlacement="start"
                label={<FormattedMessage id={'activity.showAnswerDistribution'}/>}
              />
            </div>
            <FieldSpace />
          </div>
          : null
        }

        {showGameTime ?
          <div className={classes.viewColumnFullWidthNoCenter}>
            <TextField
              variant="filled"
              fullWidth
              size="small"
              type="number"
              id="gameTime"
              name="gameTime"
              InputProps={{disableUnderline: true}}
              label={<FormattedMessage id={'activity.gameTimeInSecs'} />}
              value={gameTime}
              inputProps={{min: 0, max: 3600}}
              onChange={this.onChange}
              onKeyDown={textFieldIntegerOnKeyDown}
              helperText={<FormattedMessage id='activity.hintGameTime' />}
            />
            <FieldSpace />
          </div>
          : null
        }

        {showCheckRightOption ?
          <div className={classes.viewColumnFullWidthNoCenter}>
            <div className={classes.flexRow} style={{marginTop: -8, marginBottom: -8, paddingLeft: 12, paddingRight: 12, minHeight: 50, backgroundColor: ColorField, borderWidth: 1, borderColor: ColorFieldBorder, borderStyle: 'solid', borderRadius: BORDER_RADIUS}}>
              <FormControlLabel
                style={{marginLeft: 0, marginRight: 0}}
                control={
                  <div style={{marginLeft: app.isLTR ? 30 : 0, marginRight: app.isLTR ? 30 : 0}}>
                    <Switch
                      checked={correction}
                      onChange={this.onChecked}
                      id="correction"
                      name="correction"
                      color="primary"
                    />
                  </div>
                }
                labelPlacement="start"
                label={<FormattedMessage id={'activity.showCheckRightOption'}/>}
              />
            </div>
            <FormHelperText className={classes.helperBottom}><FormattedMessage id='activity.showCheckRightOptionHint' /></FormHelperText>
            <FieldSpace />
          </div>
          : null
        }

        {/*<div className={classes.flexRow}>*/}
        {/*  <FormControlLabel*/}
        {/*    style={{marginLeft: 0, marginRight: 0}}*/}
        {/*    control={*/}
        {/*      <Switch*/}
        {/*        checked={onlyBirthday}*/}
        {/*        onChange={this.onChecked}*/}
        {/*        id="onlyBirthday"*/}
        {/*        name="onlyBirthday"*/}
        {/*        color="primary"*/}
        {/*      />*/}
        {/*    }*/}
        {/*    labelPlacement="start"*/}
        {/*    label={<FormattedMessage id='activity.manage.birthdaySpecial'/>}*/}
        {/*  />*/}
        {/*</div>*/}
        {/*<Space horizontal={inputSpace} />*/}

        {/*{showInFunSwitch ?*/}
        {/*  <div className={classes.container}>*/}
        {/*    <div className={classes.flexRow}>*/}
        {/*      <FormControlLabel*/}
        {/*        style={{marginLeft: 0, marginRight: 0}}*/}
        {/*        control={*/}
        {/*          <Switch*/}
        {/*            checked={inChallenge}*/}
        {/*            onChange={this.onChecked}*/}
        {/*            id="inChallenge"*/}
        {/*            name="inChallenge"*/}
        {/*            color="primary"*/}
        {/*          />*/}
        {/*        }*/}
        {/*        labelPlacement="start"*/}
        {/*        label={<FormattedMessage id='activity.manage.showInFun'/>}*/}
        {/*      />*/}
        {/*    </div>*/}
        {/*    <Space horizontal={inputSpace} />*/}
        {/*  </div>*/}
        {/*  : null*/}
        {/*}*/}

        {/*{showInTrainingSwitch ?*/}
        {/*  <div className={classes.container}>*/}
        {/*    <div className={classes.flexRow}>*/}
        {/*      <FormControlLabel*/}
        {/*        style={{marginLeft: 0, marginRight: 0}}*/}
        {/*        control={*/}
        {/*          <Switch*/}
        {/*            checked={inTraining}*/}
        {/*            onChange={this.onChecked}*/}
        {/*            id="inTraining"*/}
        {/*            name="inTraining"*/}
        {/*            color="primary"*/}
        {/*          />*/}
        {/*        }*/}
        {/*        labelPlacement="start"*/}
        {/*        label={<FormattedMessage id='activity.manage.showInTraining'/>}*/}
        {/*      />*/}
        {/*    </div>*/}
        {/*    <Space horizontal={inputSpace} />*/}
        {/*  </div>*/}
        {/*  : null*/}
        {/*}*/}

        {/*{showConsumableDays ?*/}
        {/*  <div className={classes.container}>*/}
        {/*    <div className={classes.flexRow}>*/}
        {/*      <FormControl component="fieldset">*/}
        {/*        <FormLabel>*/}
        {/*          <FormattedMessage id='activity.manage.consumableWeekDays'/>*/}
        {/*        </FormLabel>*/}
        {/*        <FormGroup row={true} >*/}
        {/*          <FormControlLabel*/}
        {/*            control={<Checkbox name={"consumableWSunday"} checked={consumableWSunday} onChange={this.onChecked} />}*/}
        {/*            label={<FormattedMessage id='sunday'/>}*/}
        {/*          />*/}
        {/*          <FormControlLabel*/}
        {/*            control={<Checkbox name={"consumableWMonday"} checked={consumableWMonday} onChange={this.onChecked} />}*/}
        {/*            label={<FormattedMessage id='monday'/>}*/}
        {/*          />*/}
        {/*          <FormControlLabel*/}
        {/*            control={<Checkbox name={"consumableWTuesday"} checked={consumableWTuesday} onChange={this.onChecked} />}*/}
        {/*            label={<FormattedMessage id='tuesday'/>}*/}
        {/*          />*/}
        {/*          <FormControlLabel*/}
        {/*            control={<Checkbox name={"consumableWWednesday"} checked={consumableWWednesday} onChange={this.onChecked} />}*/}
        {/*            label={<FormattedMessage id='wednesday'/>}*/}
        {/*          />*/}
        {/*          <FormControlLabel*/}
        {/*            control={<Checkbox name={"consumableWThursday"} checked={consumableWThursday} onChange={this.onChecked} />}*/}
        {/*            label={<FormattedMessage id='thursday'/>}*/}
        {/*          />*/}
        {/*          <FormControlLabel*/}
        {/*            control={<Checkbox name={"consumableWFriday"} checked={consumableWFriday} onChange={this.onChecked} />}*/}
        {/*            label={<FormattedMessage id='friday'/>}*/}
        {/*          />*/}
        {/*          <FormControlLabel*/}
        {/*            control={<Checkbox name={"consumableWSaturday"} checked={consumableWSaturday} onChange={this.onChecked} />}*/}
        {/*            label={<FormattedMessage id='saturday'/>}*/}
        {/*          />*/}
        {/*        </FormGroup>*/}
        {/*      </FormControl>*/}
        {/*    </div>*/}
        {/*    <Space horizontal={inputSpace}/>*/}
        {/*  </div>*/}
        {/*  : null*/}
        {/*}*/}

        {/*{showConsumableTime ?*/}
        {/*  <div className={classes.container}>*/}
        {/*    <MuiPickersUtilsProvider utils={MomentUtils} locale={'en'}>*/}
        {/*      <div className={classes.flexRowNoCenter}>*/}
        {/*        <div className={classes.flexGrow}>*/}
        {/*          <TimePicker*/}
        {/*            inputVariant="outlined"*/}
        {/*            variant="inline"*/}
        {/*            size="small"*/}
        {/*            fullWidth*/}
        {/*            autoOk*/}
        {/*            format="hh:mm A"*/}
        {/*            id="hourStartAt"*/}
        {/*            name="hourStartAt"*/}
        {/*            invalidDateMessage={<FormattedMessage id='generic.invalidDateFormat'/>}*/}
        {/*            maxDateMessage={<FormattedMessage id='generic.invalidDate'/>}*/}
        {/*            minDateMessage={<FormattedMessage id='generic.invalidDate'/>}*/}
        {/*            label={<FormattedMessage id='activity.manage.startTime'/>}*/}
        {/*            minDate={this.dateNow}*/}
        {/*            value={hourStartAt}*/}
        {/*            onChange={(date) => {*/}
        {/*              this.updateState({showValidationMsg: false, hourStartAt: date})*/}
        {/*            }}*/}
        {/*            keyboardbuttonprops={{*/}
        {/*              'aria-label': 'change time',*/}
        {/*            }}*/}
        {/*            InputProps={{*/}
        {/*              endAdornment: hourStartAt ? (*/}
        {/*                <InputAdornment position="end">*/}
        {/*                  <IconButton*/}
        {/*                    onClick={() => {*/}
        {/*                      this.updateState({showValidationMsg: false, hourStartAt: null})*/}
        {/*                    }}*/}
        {/*                    onMouseDown={() => {*/}
        {/*                      this.updateState({showValidationMsg: false, hourStartAt: null})*/}
        {/*                    }}*/}
        {/*                    edge="end"*/}
        {/*                  >*/}
        {/*                    <CancelIcon />*/}
        {/*                  </IconButton>*/}
        {/*                </InputAdornment>*/}
        {/*              ) : null,*/}
        {/*            }}*/}
        {/*          />*/}
        {/*        </div>*/}
        {/*        <Space vertical={16}/>*/}
        {/*        <div className={classes.flexGrow}>*/}
        {/*          <TimePicker*/}
        {/*            inputVariant="outlined"*/}
        {/*            variant="inline"*/}
        {/*            size="small"*/}
        {/*            fullWidth*/}
        {/*            autoOk*/}
        {/*            format="hh:mm A"*/}
        {/*            id="hourEndAt"*/}
        {/*            name="hourEndAt"*/}
        {/*            invalidDateMessage={<FormattedMessage id='generic.invalidDateFormat'/>}*/}
        {/*            maxDateMessage={<FormattedMessage id='generic.invalidDate'/>}*/}
        {/*            minDateMessage={<FormattedMessage id='generic.invalidDate'/>}*/}
        {/*            label={<FormattedMessage id='activity.manage.endTime'/>}*/}
        {/*            minDate={hourStartAt ? hourStartAt : this.dateNow}*/}
        {/*            value={hourEndAt}*/}
        {/*            onChange={(date) => {*/}
        {/*              this.updateState({showValidationMsg: false, hourEndAt: date})*/}
        {/*            }}*/}
        {/*            keyboardbuttonprops={{*/}
        {/*              'aria-label': 'change time',*/}
        {/*            }}*/}
        {/*            InputProps={{*/}
        {/*              endAdornment: hourEndAt ? (*/}
        {/*                <InputAdornment position="end">*/}
        {/*                  <IconButton*/}
        {/*                    onClick={() => {*/}
        {/*                      this.updateState({showValidationMsg: false, hourEndAt: null})*/}
        {/*                    }}*/}
        {/*                    onMouseDown={() => {*/}
        {/*                      this.updateState({showValidationMsg: false, hourEndAt: null})*/}
        {/*                    }}*/}
        {/*                    edge="end"*/}
        {/*                  >*/}
        {/*                    <CancelIcon />*/}
        {/*                  </IconButton>*/}
        {/*                </InputAdornment>*/}
        {/*              ) : null,*/}
        {/*            }}*/}
        {/*          />*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    </MuiPickersUtilsProvider>*/}
        {/*    <Space horizontal={inputSpace}/>*/}
        {/*  </div>*/}
        {/*  : null*/}
        {/*}*/}

        {/*{activityData.type === constants.activity.types.SMART_AD ?*/}
        {/*  <div className={classes.container}>*/}
        {/*    <TextField*/}
        {/*      variant="outlined"*/}
        {/*      fullWidth*/}
        {/*      size="small"*/}
        {/*      type="number"*/}
        {/*      id="displayLimitPerUser"*/}
        {/*      name="displayLimitPerUser"*/}
        {/*      label={<FormattedMessage id='activity.manage.displayLimitPerUser'/>}*/}
        {/*      value={displayLimitPerUser}*/}
        {/*      inputProps={{min: 0, max: constants.activity.VALUE_DEFAULT_MAX}}*/}
        {/*      onChange={this.onChange}*/}
        {/*      helperText={<FormattedMessage id='activity.manage.leaveEmptyUnlimited'/>}*/}
        {/*    />*/}
        {/*    <Space horizontal={inputSpace}/>*/}
        {/*  </div>*/}
        {/*  : null*/}
        {/*}*/}

        {/*{showWinLimitPerUser ?*/}
        {/*  <div className={classes.container}>*/}
        {/*    <TextField*/}
        {/*      variant="outlined"*/}
        {/*      fullWidth*/}
        {/*      size="small"*/}
        {/*      type="number"*/}
        {/*      id="winLimitPerUser"*/}
        {/*      name="winLimitPerUser"*/}
        {/*      label={<FormattedMessage id='activity.manage.winLimitPerUser'/>}*/}
        {/*      value={winLimitPerUser}*/}
        {/*      inputProps={{min: 0, max: constants.activity.VALUE_DEFAULT_MAX}}*/}
        {/*      onChange={this.onChange}*/}
        {/*      helperText={<FormattedMessage id='activity.manage.leaveEmptyUnlimited'/>}*/}
        {/*    />*/}
        {/*    <Space horizontal={inputSpace}/>*/}
        {/*  </div>*/}
        {/*  : null*/}
        {/*}*/}

        {/*{showConsumeLimitPerDay ?*/}
        {/*  <div className={classes.container}>*/}
        {/*    <TextField*/}
        {/*      variant="outlined"*/}
        {/*      fullWidth*/}
        {/*      size="small"*/}
        {/*      type="number"*/}
        {/*      id="consumeLimitPerDay"*/}
        {/*      name="consumeLimitPerDay"*/}
        {/*      label={<FormattedMessage id='activity.manage.consumeLimitPerDay'/>}*/}
        {/*      value={consumeLimitPerDay}*/}
        {/*      inputProps={{min: 0, max: constants.activity.VALUE_DEFAULT_MAX}}*/}
        {/*      onChange={this.onChange}*/}
        {/*      helperText={<FormattedMessage id='activity.manage.leaveEmptyUnlimited'/>}*/}
        {/*    />*/}
        {/*    <Space horizontal={inputSpace}/>*/}
        {/*  </div>*/}
        {/*  : null*/}
        {/*}*/}

        {/*{showParticipateLimit ?*/}
        {/*  <div className={classes.container}>*/}
        {/*    <TextField*/}
        {/*      variant="outlined"*/}
        {/*      fullWidth*/}
        {/*      size="small"*/}
        {/*      type="number"*/}
        {/*      id="clickLimit"*/}
        {/*      name="clickLimit"*/}
        {/*      label={<FormattedMessage id='activity.manage.participantsLimit' />}*/}
        {/*      value={clickLimit}*/}
        {/*      inputProps={{min: 0, max: constants.activity.VALUE_DEFAULT_MAX}}*/}
        {/*      onChange={this.onChange}*/}
        {/*      helperText={<FormattedMessage id='activity.manage.leaveEmptyUnlimited'/>}*/}
        {/*    />*/}
        {/*    <Space horizontal={inputSpace}/>*/}
        {/*  </div>*/}
        {/*  : null*/}
        {/*}*/}
      </div>
    )
  }

  onChecked = (event) => {
    const value = event.target.checked;
    this.updateState({[event.target.name]: value, showValidationMsg: false});
  };

  onChange = (event) => {
    const {activityData} = this.props;
    let value = event.target.value;
    if (event.target.name === 'displayLimitPerUser'
      || event.target.name === 'consumeLimit'
      || event.target.name === 'consumeLimitPerDay'
      || event.target.name === 'consumeLimitPerUser'
      || event.target.name === 'winLimitPerUser'
      || event.target.name === 'clickLimit'
      || event.target.name === 'winnersByValue'
      || event.target.name === 'gameTime'
      || event.target.name === 'flipsNeeded'
    ) {
      let valueMax = constants.activity.VALUE_DEFAULT_MAX;
      if (event.target.name === 'consumeLimitPerUser' || event.target.name === 'flipsNeeded') {
        valueMax = this.maxTriesCount;
      } else if (event.target.name === 'gameTime') {
        valueMax = 3600;
      } else if (event.target.name === 'winnersByValue') {
        if (activityData.type === constants.activity.types.QUESTIONNAIRE) {
          valueMax = activityData.questions.length;
        }
      }
      value = ValueHelper.getDecimalValue(value);
      if (ValueHelper.getEnglishValue(value) < 0) {
        value = '0';
      } else if (ValueHelper.getEnglishValue(value) > valueMax) {
        value = valueMax;
      }
    }
    this.updateState({[event.target.name]: value, showValidationMsg: false});
  };

}

ManageActivityElements.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  activities: PropTypes.object,
  activityData: PropTypes.object,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
};

ManageActivityElements.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    activities: state.admin.activities,
    app: state.app,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
  ])(ManageActivityElements))
);
